const EuropeanWaltz = {
    name: "European Waltz",
    bpm: 135,
    signature: "3/4",
    introMeasures: 8,
    pattern: [

    ]
};

export default EuropeanWaltz;